import React from "react";

export function RadioGroup({ legend, name, items, value, onChange, error, help }) {
  return (
    <fieldset className="cv-question">
      <legend>{legend}</legend>
      {help ? <p className="cv-help">{help}</p> : null}
      <div className="cv-options">
        {items.map((item) => (
          <label key={item}>
            <input
              type="radio"
              name={name}
              value={item}
              checked={value === item}
              onChange={() => onChange(item)}
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
      {error ? <p className="cv-error">{error}</p> : null}
    </fieldset>
  );
}

export function CheckboxGroup({ legend, items, value, onChange, error, max, help }) {
  const toggle = (item) => {
    if (value.includes(item)) {
      onChange(value.filter((selected) => selected !== item));
      return;
    }
    if (!max || value.length < max) onChange([...value, item]);
  };

  return (
    <fieldset className="cv-question">
      <legend>{legend}</legend>
      {help || max ? (
        <p className="cv-help">{help || `Choose up to ${max}.`}</p>
      ) : null}
      <div className="cv-options">
        {items.map((item) => (
          <label key={item}>
            <input
              type="checkbox"
              checked={value.includes(item)}
              onChange={() => toggle(item)}
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
      {error ? <p className="cv-error">{error}</p> : null}
    </fieldset>
  );
}

export function OtherText({ label, value, onChange, error, maxLength = 160 }) {
  return (
    <label className="cv-other">
      {label}
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={maxLength}
      />
      {error ? <span className="cv-error">{error}</span> : null}
    </label>
  );
}
